// Single source of truth for the secret admin URL prefix and header value.
// Both the React Router paths and the X-Admin-Path header use this value,
// so changing REACT_APP_ADMIN_PATH in frontend/.env (and ADMIN_PATH_TOKEN
// in backend/.env) is the only thing required to rotate the secret.
export const ADMIN_PATH = (process.env.REACT_APP_ADMIN_PATH || "").trim();
export const ADMIN_BASE = ADMIN_PATH ? `/${ADMIN_PATH}` : "/__admin_disabled__";
